import {
  FETCHING_INTEGRATION_OPPORTUNITIES, FETCHING_INTEGRATION_OPPORTUNITIES_SUCCEEDED,
  FETCHING_INTEGRATION_OPPORTUNITIES_FAILED, INVALIDATE_INTEGRATION_OPPORTUNITIES
} from './actionTypes.jsx';

import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const OPPORTUNITY_BASE_URL = `${apiUrl}/api/2.0/opportunities`;

export function fetchOpportunities(query, page, limit){
  return function (dispatch) {
    dispatch(fetchingOpportunities());

    var params = {
      query: query,
      page: page,
      limit: limit
    }

    return axios({
      method: 'GET',
      url: OPPORTUNITY_BASE_URL,
      params: params
    })

    .then(response =>
      dispatch(fetchingOpportunitiesSuccedded(response.data))
    )

    .catch(error =>
      dispatch(fetchingOpportunitiesFailed(error))
    )
  }
}


function fetchingOpportunities(){
  return {
    type: FETCHING_INTEGRATION_OPPORTUNITIES,
    payload: {}
  }
}

function fetchingOpportunitiesSuccedded(json){
  return {
    type: FETCHING_INTEGRATION_OPPORTUNITIES_SUCCEEDED,
    payload: json
  }
}

  

function fetchingOpportunitiesFailed(error){
  return {
    type: FETCHING_INTEGRATION_OPPORTUNITIES_FAILED,
    payload: error
  }
}

export function invalidateOpportunities(){
  return {
    type: INVALIDATE_INTEGRATION_OPPORTUNITIES,
    payload: {}
  }
}